<template>
  <v-container
    class="error-page full-height pt-10"
    tag="section"
  >
    <v-row
      class="text-center mt-10"
    >
      <v-col cols="12" lg="4" offset-lg="4">
        <v-img 
          :src="require(`@/assets/logo-perfect.png`)"
        ></v-img>
      </v-col>
      <v-col cols="12">
        <h1>
          Грешка 404
        </h1>

        <div class="display-3 mb-5 mt-10">
          Страницата не е намерена
        </div>

        <v-btn
          color="primary"
          @click="goToAvailablePath"
        >
          <v-icon class="mr-2">mdi-reply</v-icon>
          Към {{routeToGo.name ? routeToGo.name : ''}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { saveWrongPath } from "@/api/error";
  export default {
    name: 'PagesError',
    data(){
      return {
        routeToGo: {
          name: '',
          path: ''
        }
      }
    },
    mounted(){
      this.getFirstAvailableRoute();
      this.saveWrongPathData();
    },
    methods: {
      goToAvailablePath(){
        this.$router.push({ path: this.routeToGo.path })
      },
      getFirstAvailableRoute(){
        let route;
        for(let r of this.$router.options.routes){
          if(r.path !== '/' && r.path !== '/authentication' && r.path != '/*'){
            route = r;
            break;
          }
        }

        if(route.hidden){
          if(route.children){
            for(let r of route.children){
              if(!r.hidden){
                this.routeToGo = r;
              }
            }
          }
        } else {
          this.routeToGo = route;
        }
      },
      saveWrongPathData(){
        saveWrongPath(this.$router.currentRoute.path)
      },
    }
  }
</script>

<style lang="sass">
  .error-page
    h1
      font-size: 8rem
</style>
